import type { Scroll } from "@/lib/supabase";
import {
  buildFolderArchiveMap,
  isScrollLiveOnWorkspaceHome,
  type FolderArchiveFields,
} from "@/lib/archive-scope";

export const RECENT_NOTES_HOME_MAX = 5;

/**
 * Workspace notes most recently touched, by `updated_at` only.
 * Excludes deleted/archived/trashed-parent. No pin, star, priority, or manual ordering.
 */
export function getRecentNotesByActivity(
  scrolls: Scroll[],
  max: number = RECENT_NOTES_HOME_MAX,
  folders: FolderArchiveFields[] = [],
): Scroll[] {
  const folderById = buildFolderArchiveMap(folders);
  return scrolls
    .filter((s) => isScrollLiveOnWorkspaceHome(s, folderById))
    .sort(
      (a, b) =>
        new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime(),
    )
    .slice(0, max);
}
